import { createContext, useContext, useMemo, useState } from "react";

const NavigationContext = createContext(null);

export const useNavigationContext = () => {
  const v = useContext(NavigationContext);
  if (!v) {
    throw new Error(
      "useNavigationContext must be used inside NavigationProvider",
    );
  }
  return v;
};

export const NavigationProvider = ({ children }) => {
  const [showSideBar, setShowSideBar] = useState(false);

  const value = useMemo(() => ({ showSideBar, setShowSideBar }), [showSideBar]);

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};
